module.exports = __webpack_public_path__ + "img/deri.965d6c2d.svg";